/* eslint-disable react/no-unstable-nested-components */
import ContentWrapper from "@/components/layouts/DashboardLayout/Content";
import { columns } from "./siteProductManagement.constants";
import routes from "@/routes";
import FilterComponent from "./components/FilterComponent";
import { Toast, useTypedDispatch, useTypedSelector } from "@/app/store";
import { useGetUserInfoQuery } from "@/rtk-query/userQueries";
import { siteProductManagementSlide } from "./siteProductManagement.slice";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import useIntersectionObserver from "@/hooks/useIntersectionObserver";
import { Row, Spin, notification, Button, Dropdown } from "antd";
import type { MenuProps } from "antd";
import { checkTotalAllItem, getError, useCheckPermission } from "@/utils/helpers";
import message from "@/utils/message";
import { useDeleteProductMutation, useExportProductMutation, useGetProductListQuery, useRestoreProductMutation } from "@/rtk-query/productQueries";
import { ProductType, WarehouseType } from "@/utils/types";
import SearchArea from "../MasterProductManagement/components/SearchArea";
import useDebounce from "@/hooks/useDebounce";
import { useReactToPrint } from "react-to-print";
import BoxIcon from "@/assets/icons/BoxIcon";
import { CompanySelectType } from "../WarehouseManagement/warehouseManagement.slice";
import styles from "./siteProductManagement.module.less";
import FilterIcon from "@/assets/icons/FilterIcon";
import { TableRowSelection } from "antd/es/table/interface";
import C from "@/utils/constants";
import TableHeaderFixed from "@/components/TableCustom/tableHeaderFixed";
import ExportQrPrint from "./components/ExportQrPrint";

function SiteProductManagementModule() {
  const editPerm = useCheckPermission(C.PERMISSIONS.PRODUCT_EDIT);
  const deletePerm = useCheckPermission(C.PERMISSIONS.PRODUCT_EDIT);

  const [data, setData] = useState<Array<any>>([]);
  const [page, setPage] = useState(1);
  const [loadingList, setLoadingList] = useState<Array<string | number>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedAllQR, setSelectedAllQR] = useState<boolean>(false);
  const [quantitySelected, setQuantitySelected] = useState<number>(0);
  const [selectPrintList, setSelectPrintList] = useState<any>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [exportExcel, setExportExcel] = useState<boolean>(false);
  const [binCode, setBinCode] = useState<string>("");
  const [listBindCode, setListBinCode] = useState<any[]>([]);
  const [dataBindCode, setdataBindCode] = useState<any[]>([]);
  const [position, setPosition] = useState<string>("");
  const [listPosition, setListPosition] = useState<any[]>([]);
  const [dataPosition, setdataPosition] = useState<any[]>([]);
  const searchDebounce = useDebounce(search, 300);
  const { companySelected, wareHouseSelected } = useTypedSelector((store) => store.siteProductManagementSlide);
  const [disable, setDisabled] = useState<boolean>(false);
  const enablePagination = true;
  const { currentData, isFetching, refetch } = useGetProductListQuery({
    page,
    companyId: companySelected?.id || "",
    warehouseId: wareHouseSelected?.id || "",
    position: "",
    pageSize: C.PAGE_SIZE,
    search: searchDebounce,
    isLoading: undefined,
  });

  const { currentData: userInfo } = useGetUserInfoQuery();
  const [deleteProductApi] = useDeleteProductMutation();
  const [restoreProductApi] = useRestoreProductMutation();
  const [exportProductApi] = useExportProductMutation();
  const dispatch = useTypedDispatch();
  const { onSelectCompany, onSelectWareHouse } = siteProductManagementSlide.actions;

  const resetSelectQrList = () => {
    setSelectedRowKeys([]);
    setSelectPrintList([]);
    setQuantitySelected(0);
  };

  const handleChangePageSize = (pageChange: number) => {
    resetSelectQrList();
    setLoading(true);
    setPage(pageChange);
  };

  const handleSelectCompany = (value: CompanySelectType) => {
    setLoading(true);
    dispatch(onSelectCompany(value));
    setPage(1);
    resetSelectQrList();
    setDisabled(true);
  };

  const handleSelectWarehouse = (value: WarehouseType | null) => {
    setLoading(true);
    dispatch(onSelectWareHouse(value));
    setPage(1);
    resetSelectQrList();
    setDisabled(true);
  };

  const handleLoaded = (id: string | number) => {
    setTimeout(() => {
      setLoadingList(loadingList.filter((item) => item !== id));
    }, 300);
  };

  const handleDeleteRestore = async (id: string | number, type?: "delete" | "restore") => {
    setLoadingList([...loadingList, id]);
    Toast.close();
    const contentElement: any = document.getElementById("content");
    contentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    try {
      type === "delete" ? await deleteProductApi(id).unwrap() : await restoreProductApi(id).unwrap();
      notification.success({
        message: message.SUCCESSFULLY,
      });
      handleLoaded(id);
      setPage(1);
      refetch();
    } catch (error) {
      notification.error({
        key: "error_product_del",
        message: getError(error),
      });
      handleLoaded(id);
      refetch();
    }
  };

  const handleDeletePopup = (id: string | number) => {
    Toast.delete({
      isOpen: true,
      title: "Are you sure you want to delete this product?",
      description: "You will not able to view and edit this product’s information.",
      cancelText: "Cancel",
      okText: "Delete",
      onCancel: () => {
        Toast.close();
      },
      onOk: () => handleDeleteRestore(id, "delete"),
      okStyle: {
        background: "#F32121",
      },
    });
  };

  useEffect(() => {
    handleSelectCompany(!companySelected ? null : companySelected);
  }, [userInfo]);

  // Intersection Observer
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, {});
  const isVisible = !!entry?.isIntersecting;

  useEffect(() => {
    const paginationData = page === 1 ? currentData?.data || [] : [...(currentData?.data || [])];
    setData(paginationData);

    const listCode: Array<any> = [];
    const listBindCodeAdd: Array<any> = [];
    const listPosition: Array<any> = [];
    const listPositionAdd: Array<any> = [];
    const dataProduct = paginationData;

    for (let i = 0; i < dataProduct?.length; i++) {
      if (!listCode.includes(dataProduct[i].bin?.binCode)) {
        listCode.push(dataProduct[i].bin?.binCode);
      }
    }

    for (let i = 0; i < dataProduct?.length; i++) {
      if (!listPosition.includes(dataProduct[i]?.position)) {
        listPosition.push(dataProduct[i]?.position);
      }
    }

    listCode.forEach((item, index) => {
      listBindCodeAdd.push({
        label: item,
        key: index,
      });
    });

    listPosition.forEach((item, index) => {
      listPositionAdd.push({
        label: item,
        key: index,
      });
    });

    setListBinCode(listBindCodeAdd);
    setListPosition(listPositionAdd);

    setLoading(false);
  }, [currentData, refetch, page]);

  useEffect(() => {
    setLoading(true);
  }, [searchDebounce]);

  useEffect(() => {
    if (isVisible) {
      setPage((currentData?.page || 0) + 1);
    }
  }, [isVisible]);

  const refPrint = useRef<HTMLDivElement>(null);
  const refRfidPrint = useRef<HTMLDivElement>(null);

  // Title FilterBinCode
  const TitleBinCode = (): JSX.Element => {
    const items: MenuProps["items"] | Array<any> = [];

    listBindCode.forEach((item) => {
      items.push({
        label: <div>{item.label === binCode ? <span style={{ color: "#F36F21" }}>{item.label}</span> : <span>{item.label}</span>}</div>,
        key: item.label,
        onClick: (e) => {
          if (e.key === binCode) {
            setBinCode("");
            setdataBindCode([]);
            return;
          }
          setBinCode(e.key);

          const filter = data.filter((item) => item.bin.binCode === e.key);
          setdataBindCode(filter);
        },
      });
    });

    return (
      <Dropdown className={styles.dropdownBin} menu={{ items }} trigger={["click"]}>
        <div style={{ cursor: "pointer" }}>
          <span style={{ marginRight: 8 }}>Bin Code</span>
          <FilterIcon color={binCode ? `#F36F21` : "unset"} />
        </div>
      </Dropdown>
    );
  };

  // Title Position
  const TitlePosition = (): JSX.Element => {
    const items: MenuProps["items"] | Array<any> = [];
    listPosition.forEach((item) => {
      items.push({
        label: <div>{item.label === position ? <span style={{ color: "#F36F21" }}>{item.label}</span> : <span>{item.label}</span>}</div>,
        key: item.label,
        onClick: (e) => {
          if (e.key === position) {
            setPosition("");
            setdataPosition([]);
            return;
          }
          setPosition(e.key);

          const filter = data.filter((item) => item.position === e.key);
          setdataPosition(filter);
        },
      });
    });

    return (
      <Dropdown className={styles.dropdownBin} menu={{ items }} trigger={["click"]}>
        <div style={{ cursor: "pointer" }}>
          <span style={{ marginRight: 8 }}>Position</span>
          <FilterIcon color={position ? `#F36F21` : "unset"} />
        </div>
      </Dropdown>
    );
  };

  const dataFilterd = (): any[] => {
    let arrayAfterFilter: any[] = [];
    if (binCode === "" && position === "") {
      arrayAfterFilter = data ?? [];
    }
    if (binCode) {
      arrayAfterFilter = dataBindCode;
    }
    if (position) {
      arrayAfterFilter = dataPosition;
    }
    if (binCode !== "" && position !== "") {
      const filter = data.filter((item) => item.position === position && item.bin.binCode === binCode);
      arrayAfterFilter = filter;
    }
    return arrayAfterFilter;
  };

  // Export QR list
  const handlePrint = useReactToPrint({
    content: () => {
      return refPrint.current;
    },
    pageStyle: `

    @page {
      margin: 0;
      size: 76.2mm 25.4mm;
      padding: 1mm;
      
    }`,
    documentTitle: "Product management",
  });

  const handleRfidPrint = useReactToPrint({
    content: () => {
      return refRfidPrint.current;
    },
    pageStyle: `

    @page {
      margin: 0;
      size: 76.2mm 25.4mm;
      padding: 1mm;
      
    }`,
    documentTitle: "Product management",
  });

  const exportPrint = () => {
    setExportExcel(!exportExcel);
    setSelectedAllQR(false);
    resetSelectQrList();
    setDisabled(true);
  };

  const handleExportExcel = async () => {
    try {
      await exportProductApi({
        companyId: companySelected?.id,
        warehouseId: wareHouseSelected?.id,
        binId: "",
        isLoading: undefined,
      }).unwrap();
      setDisabled(true);
    } catch (error) {
      notification.error({
        message: getError(error),
        key: "site_product",
      });
    }
  };

  // eslint-disable-next-line react/no-unstable-nested-components, @typescript-eslint/no-unused-vars
  const HideAllSelectedItem = ({ dataPrint }: { dataPrint: Array<any> }): JSX.Element => {  
    return (
      <div
        style={{
          marginBottom: 12,
          marginLeft: 4,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div>
          <p
            style={{
              margin: 0,
              marginRight: 16,
              fontWeight: 500,
            }}
          >
            <>
              <span style={{ fontWeight: 600, paddingRight: 4 }}>
                {quantitySelected}
                <span style={{ fontWeight: 500 }}> selected of total </span>
                {data.length}
              </span>
            </>
          </p>
        </div>
        <Button
          style={{
            border: 0,
            backgroundColor: "#4877dd",
            color: "#fff",
            fontSize: 12,
            padding: "6px 12px",
            fontWeight: 600,
            borderRadius: 5,
            cursor: "pointer",
          }}
          disabled={disable}
          onClick={() => handlePrint()}
        >
          Export QR
        </Button>
        <Button
          style={{
            border: 0,
            backgroundColor: "#4877dd",
            color: "#fff",
            fontSize: 12,
            padding: "6px 12px",
            fontWeight: 600,
            borderRadius: 5,
            cursor: "pointer",
            marginLeft: "0.5rem",
          }}
          disabled={disable}
          onClick={() => handleRfidPrint()}
        >
          Export RFID Sticker
        </Button>
        <Button
          style={{
            border: 0,
            backgroundColor: "#8591a5",
            color: "#fff",
            fontSize: 12,
            padding: "6px 12px",
            fontWeight: 600,
            borderRadius: 5,
            cursor: "pointer",
            marginLeft: "0.5rem",
          }}
          onClick={() => exportPrint()}
        >
          Cancel
        </Button>
      </div>
    );
  };

  const onChange = useCallback((selectedKeys: React.Key[], selectedRows: any) => {
    setSelectedRowKeys(selectedKeys);
    setSelectPrintList(selectedRows);
    setQuantitySelected(selectedRows.length);
    setDisabled(!selectedRows?.length);
  }, []);

  const getCheckboxProps = useCallback(
    (record: any) => ({
      disabled: record.deletedAt,
    }),
    []
  );

  const onSelectAll = useCallback((selected: boolean) => {
    setSelectedAllQR(selected);
  }, []);

  const rowSelector: TableRowSelection<any> = useMemo(
    () => ({
      preserveSelectedRowKeys: true,
      onChange,
      getCheckboxProps,
      onSelectAll,
      selectedRowKeys,
    }),
    [onChange, getCheckboxProps, onSelectAll, selectedRowKeys]
  );

  const rowSelection: TableRowSelection<any> = useMemo(() => {
    return {
      type: "checkbox",
      ...rowSelector,
      hideSelectAll: !exportExcel,
      columnTitle: exportExcel ? undefined : "",
      renderCell: exportExcel ? undefined : () => null,
    };
  }, [exportExcel, rowSelector]);

  return (
    <ContentWrapper
      dataBreadCrumb={[
        {
          title: routes.siteProductList.title,
          icon: <BoxIcon />,
          url: routes.siteProductList.path,
        },
      ]}
      renderFilter={
        <FilterComponent
          type="list"
          onSelectCompany={handleSelectCompany}
          onSelectWareHouse={handleSelectWarehouse}
          onPrint={() => exportPrint()}
          onExport={() => handleExportExcel()}
        />
      }
      headerContent={
        <div
          style={{
            display: "flex",
            justifyContent: exportExcel ? "space-between" : "end",
          }}
        >
          {exportExcel && <HideAllSelectedItem dataPrint={selectPrintList} />}
          <SearchArea
            value={search}
            onChange={(value: string) => {
              setSearch(value);
              setPage(1);
            }}
          />
        </div>
      }
      paginationEnable={enablePagination}
      currentPage={page}
      total={currentData?.total ?? C.PAGE_SIZE}
      onChangePage={handleChangePageSize}
    >
      <TableHeaderFixed
        rowSelection={rowSelection}
        data={dataFilterd()}
        columns={columns({
          onDelete: handleDeletePopup,
          onRestore: (id) => handleDeleteRestore(id, "restore"),
          canEdit: editPerm,
          canDelete: deletePerm,
          loadingList,
          titleBinCode: <TitleBinCode />,
          titlePosition: <TitlePosition />,
        })}
        total={checkTotalAllItem({
          page,
          companyId: companySelected?.id || "",
          search: wareHouseSelected?.identityCode || "",
        })}
        loading={loading}
      />
      {isFetching && (
        <Row
          ref={ref}
          justify="center"
          style={{
            padding: 36,
          }}
        >
          <Spin tip="Loading" size="large" />
        </Row>
      )}
      {/* HTML Print */}
      <div
        className="print-source"
        ref={refPrint}
        style={{
          height: "25.4mm",
        }}
      >
        {(selectPrintList || []).map(
          (product: ProductType, index: number) => !product.deletedAt && <ExportQrPrint type="qrCode" productItem={product} key={index} />
        )}
      </div>
      <div
        className="print-source"
        ref={refRfidPrint}
        style={{
          height: "25.4mm",
        }}
      >
        {(selectPrintList || []).map(
          (product: ProductType, index: number) => !product.deletedAt && <ExportQrPrint type="rfidCode" productItem={product} key={index} />
        )}
      </div>
    </ContentWrapper>
  );
}

export default SiteProductManagementModule;
